import React from 'react';
import DiscoverGroupsOrClubsPanel from './DiscoverGroupsOrClubsPanel';

/** Thin wrapper kept for existing call sites (UserProfile, FeedPage) — see DiscoverGroupsOrClubsPanel. */
const DiscoverClubsPanel: React.FC = () => <DiscoverGroupsOrClubsPanel kind="club" />;

export default DiscoverClubsPanel;
